// Collaboration related redux action code. Dependent on errand. This mainly to
// seperate it from errand which is hugh code now.
import update from 'immutability-helper';
import {
	getCRMdatas,
	getExternalexpertEdit,
	getExternalexpertLightWithAction,
	getExternalexpertList,
	getExternalExpertQueries,
	getExternalexpertThread,
	getOneCollaborationQueryRecipients,
	postCollaborationAnswers,
	postExternalexpertAnswerSave,
	postExternalexpertSend,
	postResendExternalexpertSend,
	postExternalexpertUpdate,
	postExternalexpertLastSave
} from './ajax';
import { loadList } from './workflow';
import {
	checkEmptyAnswer,
	checkEmptyRecipient,
	checkTranslate,
	canSendCollab,
	errand as errandMap
} from './errand';
import {
	changeCollaborationRole,
	reloadCurrentExpert,
	updateCurrentExpertIDs,
	updateExpertAnswerState,
	saveCollabStart,
	agentEENotTyping
} from '../collaborate';
import {
	invalidateCache
} from '../domain';
import {
	changeHistorySelections
	, selectShowReply
	, toggleChatNavDD
	, selectChatReplyTab
	, markEELastSaveTriggered
} from '../errand';
import {
	keyEEAnswerSave,
	keyExternalexpertEdit,
	keyFetchExternalExpertList,
	keyFetchExternalQueries,
	keyFetchExternalExpertThread,
	keySendEE,
	keyUpdateAnswerEE,
	keySavedEE,
	keyTurnExternalExpertLightOff,
	keyCRMDataFetch
} from '../../constants/keys';
import {
	CHAT_DONE_GETTING_CANDIDATES,
	CHAT_GETTING_CANDIDATES,
	CHAT_SET_CANDIDATES,
	ERRAND_CLASSIFICATION,
	XFER_DOMAIN_EE_EDIT,
	XFER_DOMAIN_EE_LIST,
	SNAPSHOT_COLLAB_EDITOR_BASELINE,
	AGENTEE_BUSY_TYPING,
	SAVE_EE,
	RC_EMAIL
} from '../../constants/constants';
import {
	async,
	externalExpertEditDomainID,
	multiAsync,
	mcamResult
} from '../../util';
import {
	cachedAsync
} from './cache';
import { emptyArray } from '../../../common/constants';
import {
	COL_MASK_LIGHT_ON,
	D_EE_EDIT,
	EXPERT_ANS_IDLE,
	EXPERT_ANS_SENDING,
	EXPERT_ANS_SAVING,
	ROLE_AGENT,
	RPLY_ERRAND,
	RPLY_COLLABORATE,
	RPLY_EXT_FWD,
	TMR_AUTO_SAVE,
	THROTTLED_TMR,
	TMR_AGENT_NO_TYPING
} from '../../../common/v5/constants';
import {
	checkEmptyHTML,
	isChatAndCollaborateInternalChat,
	isCollaboration,
	getUniqueAddress
} from '../../../common/v5/helpers';
import {
	getChatCandidates,
	refreshChatErrandCollaboration,
	subscribeAgentPresence,
	unsubscribeAgentPresence,
} from './echat';
import {
	currentChatErrand,
	currentCollabChannel,
	currentErrandReplyChannel,
	getCurrentErrand,
	collaborationInputs,
	isEEActionInProgressSelector,
	getEEUploadedAttachments,
	isCollabInputsChangedMemoize,
	isEEIdleAnswer
} from '../../selectors/errand';
import {
	getDomainEEThreads
} from '../../selectors/collaborate';
import { 
	popErrorOnly, 
	togglePopAlert,
	togglePopWaiting,
	clearPopWaiting
  } from '../hmf';
import {
	addTimeout,
	removeTimeout
} from 'redux-timeout';

////////////////////////////////////////////////////////////////////////////////
// AJAX
//
const eeEdit = (errandID, query, answer, reload) => (dispatch, getState) => {

	const draft = getState().app.errand.collaborationInputs;
	dispatch({
		type: SNAPSHOT_COLLAB_EDITOR_BASELINE,
		payload: {
			errandID,
			update_to: draft.update_to,
			update_cc: draft.update_cc,
			update_bcc: draft.update_bcc,
			update_subject: draft.update_subject,
			update_answer: draft.update_answer
		}
	});
	return dispatch(cachedAsync(
		externalExpertEditDomainID(errandID, query, answer),
		D_EE_EDIT,
		async(
			getExternalexpertEdit({params: JSON.stringify({errand: errandID, query,
				answer})}),
			errandMap[keyExternalexpertEdit],
			{errand: errandID, query, answer}
		),
		XFER_DOMAIN_EE_EDIT,
		reload
	));
};

export const fetchEEList = (id, reload) => (dispatch, getState) => {
	const q = {errand: id};
	return dispatch(cachedAsync(
		id,
		'externalExpertList',
		async(getExternalexpertList(q), errandMap[keyFetchExternalExpertList],
			q),
		XFER_DOMAIN_EE_LIST,
		reload))
		.then(response => {
			if(response.error) {
				return Promise.reject(new Error(response.error));
			}
			return response;
		})
		.catch(err => {
			// TODO: send notification error here
		});
};

export const fetchEEThread = (thread, errandId, read) => (dispatch, getState) => {
	const eelist = getState().domain.externalExpertList.byId[errandId];
	let lightoff;
	if(typeof read !== 'undefined') {
		// fetch collaboration thread from errand owner.
		lightoff = true;
		if(eelist && eelist.list) {
			$.each(eelist.list, (i,v) => {
				if (v.id !== thread && !v.read &&
					(v.flag & COL_MASK_LIGHT_ON)) {
					// NOTE: COL_MASK_LIGHT_ON detection is needed as it is to
					// avoid light is not off because of thread that has no
					// answer and still unread. This behaviour different from
					// previous version which seem more like a bug.
					lightoff = false;
					return false;
				}
			});
		}
	}
	// read can be undefined in which case should happen during internal
	// collaboration to avoid the query marked as read.
	const q = {thread, errand: errandId, read, lightoff};
	return dispatch(multiAsync(getExternalexpertThread(q),
		errandMap[keyFetchExternalExpertThread], q));
};

const fetchExternalQueries = id => async(getOneCollaborationQueryRecipients(id),
	errandMap[keyFetchExternalQueries], {errand: id}
);

const sendEE = p => (dispatch, getState) => {
	return dispatch(async(postExternalexpertSend({params: JSON.stringify(p)}),
		errandMap[keySendEE]))
		.then(response => {
			if(!response.success) {
				return Promise.reject(new Error(response.error));
			}
			return response;
		})
		.catch(err => {
			dispatch(popErrorOnly(err))
			// TODO: send notification error here
		});
};

const updateEE = p => async(postExternalexpertUpdate({params: JSON.stringify(p)}),
		errandMap[keyUpdateAnswerEE]
);

const answerQuery = p => (dispatch, getState) => dispatch(async(
	postCollaborationAnswers({params: JSON.stringify(p)}),
	errandMap[keyEEAnswerSave]))
	.then(response => {
		if(!response.success) {
			return Promise.reject(new Error(response.error));
		}
		return response;
	})
	.catch(err => {
		// TODO: send notification error here
	});

const refreshCollaborationAtList = (chat, origin) => dispatch => {
	if (chat) {
		refreshChatErrandCollaboration(chat.sessionId)
	} else {
		dispatch(loadList(origin)) // TODO: use websocket once ready
		return true
	}
}

// TODO: there are two places use the same action in 4.5 for EE. Check that out.
export const toggleCollaborationLight = errandID => (dispatch, getState) => {
	const p = {errand: errandID};
	return dispatch(async(getExternalexpertLightWithAction(p),
		errandMap[keyTurnExternalExpertLightOff], p))
		.then(response => {
			if(response.error) {
				return Promise.reject(new Error(response.error));
			}
			const state = getState();
			dispatch(refreshCollaborationAtList(
				currentChatErrand(state),
				"toggleCollaborationLight"
			));
			dispatch(invalidateCache(errandID, 'externalExpertList'));
			if (errandID === getCurrentErrand(state)) {
				dispatch(fetchEEList(errandID, true));
			}
			return response;
		})
		.catch(err => {
			// TODO: send notification error here
		});
};

////////////////////////////////////////////////////////////////////////////////
// Actions code
//
// function getSelectedInternalCollaborators(selectedAgents) {
// 	if(!selectedAgents) {
// 		return [];
// 	}
// 	let agentIDs = [];
// 	$.each(selectedAgents, (i,v) => {
// 		agentIDs.push(parseInt(v, 10));
// 	});
// 	return agentIDs;
// }

const onLoadFetchEEThread = (thread, errandId) => dispatch => {
	return dispatch(fetchEEThread(thread, errandId, false))
		.then(() => {
			// switch to expert role and open collaboration
		})
		.then(() => {
			// clear direct EE thread loading
		});
};

export const multiDispatchesEE = (errand, reload) => (dispatch, getState) => {
	let dispatches = [
		dispatch(fetchExternalQueries(errand)),
		dispatch(fetchEEList(errand, reload))
	];
	const directLoad = getState().app.errand.collaborationInputs.onLoad;
	if(directLoad) {
		dispatches.push(dispatch(onLoadFetchEEThread(directLoad.threadID,
			errand)));
	}
	// get the main thing first
	return $.when(...dispatches);
};

export const refreshCollaborationData = (id, thread, chat) => (
	dispatch,
	getState
) => {
	const result = dispatch(refreshCollaborationAtList(
		chat,
		"refreshCollaborationData"
	));
	dispatch(invalidateCache(thread, 'externalExpertThreads'));
	if (id === getCurrentErrand(getState())) {
		dispatch(reloadCurrentExpert()); // TODO: remove this once websocket ready
		dispatch(multiDispatchesEE(id, true)); // TODO: remove this once websocket ready
	}
	dispatch(selectShowReply(RPLY_ERRAND, false));
	return result
};

// Inline image processing functions for collaboration (similar to manual errand processing)
const dataURItoBlobs = (dataURI) => {
	const byteString = atob(dataURI.split(',')[1]);
	const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
	const ab = new ArrayBuffer(byteString.length);
	const ia = new Uint8Array(ab);
	for (let i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}
	return new Blob([ab], {type: mimeString});
};

const processCollaborationInlineImages = async (htmlContent, preserveBase64ForClient = false) => {
	if (!htmlContent) return { processedContent: htmlContent, attachmentIds: [] };
	
	// If preserveBase64ForClient is true, preserve base64 with proper resize attributes for client compatibility
	if (preserveBase64ForClient) {
		
		// Process both standalone images and images within figures
		let processedContent = htmlContent;
		
		processedContent = processedContent.replace(
			/<figure([^>]*?)class="([^"]*image[^"]*)"([^>]*?)>\s*<img([^>]*?)src="(data:image\/[^"]*)"([^>]*?)>\s*<\/figure>/gi,
			(match, figureBeforeClass, figureClasses, figureAfterClass, imgBefore, dataURI, imgAfter) => {
				let figureAlignment = '';
				if (figureClasses.includes('image-style-align-left') || figureClasses.includes('align-left')) {
					figureAlignment = 'left';
				} else if (figureClasses.includes('image-style-align-right') || figureClasses.includes('align-right')) {
					figureAlignment = 'right';
				} else if (figureClasses.includes('image-style-align-center') || figureClasses.includes('align-center')) {
					figureAlignment = 'center';
				}
				
				const figureAttrs = `${figureBeforeClass} ${figureAfterClass}`;
				const figureStyleMatch = figureAttrs.match(/\bstyle\s*=\s*["']([^"']*)["']/i);
				const figureStyle = figureStyleMatch ? figureStyleMatch[1] : '';
				const figureWidthPxMatch = figureStyle.match(/(?:^|[;\s])width\s*:\s*(\d+(?:\.\d+)?)px/i);
				const figureHeightPxMatch = figureStyle.match(/(?:^|[;\s])height\s*:\s*(\d+(?:\.\d+)?)px/i);
				const figureWidthPctMatch = figureStyle.match(/(?:^|[;\s])width\s*:\s*(\d+(?:\.\d+)?)%/i);

				let imgAttrs = `${imgBefore}src="${dataURI}"${imgAfter}`;
				if (figureWidthPxMatch || figureHeightPxMatch || figureWidthPctMatch) {
					const origWidthMatch = imgAttrs.match(/\bwidth\s*=\s*["']?(\d+(?:\.\d+)?)["']?/i);
					const origHeightMatch = imgAttrs.match(/\bheight\s*=\s*["']?(\d+(?:\.\d+)?)["']?/i);
					const origWidth = origWidthMatch ? parseFloat(origWidthMatch[1]) : null;
					const origHeight = origHeightMatch ? parseFloat(origHeightMatch[1]) : null;

					const aspectRatioMatch = imgAttrs.match(/aspect-ratio\s*:\s*(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)/i);
					const ratioW = aspectRatioMatch ? parseFloat(aspectRatioMatch[1]) : origWidth;
					const ratioH = aspectRatioMatch ? parseFloat(aspectRatioMatch[2]) : origHeight;

					let targetW = figureWidthPxMatch ? Math.round(parseFloat(figureWidthPxMatch[1])) : null;
					let targetH = figureHeightPxMatch ? Math.round(parseFloat(figureHeightPxMatch[1])) : null;

					if (!targetW && figureWidthPctMatch && origWidth) {
						targetW = Math.round((origWidth * parseFloat(figureWidthPctMatch[1])) / 100);
					}
					if (targetW && !targetH && ratioW && ratioH && ratioW > 0) {
						targetH = Math.round((targetW * ratioH) / ratioW);
					} else if (targetH && !targetW && ratioW && ratioH && ratioH > 0) {
						targetW = Math.round((targetH * ratioW) / ratioH);
					}

					if (targetW) {
						if (origWidthMatch) {
							imgAttrs = imgAttrs.replace(/\bwidth\s*=\s*["']?\d+(?:\.\d+)?["']?/i, `width="${targetW}"`);
						} else {
							imgAttrs += ` width="${targetW}"`;
						}
					}
					if (targetH) {
						if (origHeightMatch) {
							imgAttrs = imgAttrs.replace(/\bheight\s*=\s*["']?\d+(?:\.\d+)?["']?/i, `height="${targetH}"`);
						} else {
							imgAttrs += ` height="${targetH}"`;
						}
					}
				}

				let imgContent = `<img${imgAttrs}>`;
				let alignStyle = '';
				if (figureAlignment === 'left') {
					alignStyle = 'float: left; margin-right: 10px;';
				} else if (figureAlignment === 'right') {
					alignStyle = 'float: right; margin-left: 10px;';
				} else if (figureAlignment === 'center') {
					alignStyle = 'display: block; margin-left: auto; margin-right: auto;';
				}
				if (alignStyle) {
					if (/\bstyle\s*=\s*["']/i.test(imgContent)) {
						imgContent = imgContent.replace(/\bstyle\s*=\s*(["'])/i, `style=$1${alignStyle} `);
					} else {
						imgContent = imgContent.replace('<img', `<img style="${alignStyle}"`);
					}
				}
				return imgContent;
			}
		);
		
		processedContent = processedContent.replace(
			/<img([^>]*?)src="(data:image\/[^"]*)"([^>]*?)>/g,
			(match, beforeSrc, dataURI, afterSrc) => {
				const allAttributes = beforeSrc + afterSrc;
				
				const widthMatch = allAttributes.match(/\bwidth\s*=\s*["']?(\d+(?:\.\d+)?)["']?/i);
				const heightMatch = allAttributes.match(/\bheight\s*=\s*["']?(\d+(?:\.\d+)?)["']?/i);
				
				const classMatch = allAttributes.match(/\bclass\s*=\s*["']([^"']*)["']/i);
				const alignMatch = allAttributes.match(/\balign\s*=\s*["']([^"']*)["']/i);
				
				const styleMatch = allAttributes.match(/\bstyle\s*=\s*["']([^"']*)["']/i);
				
				let newAttributes = '';
				let inlineStyle = '';
				let imageAlignment = '';
				
				if (widthMatch) {
					const width = Math.round(parseFloat(widthMatch[1]));
					newAttributes += ` width="${width}"`;
					inlineStyle += `width: ${width}px; `;
				}
				if (heightMatch) {
					const height = Math.round(parseFloat(heightMatch[1]));
					newAttributes += ` height="${height}"`;
					inlineStyle += `height: ${height}px; `;
				}
				
				if (classMatch) {
					const classes = classMatch[1];
					if (classes.includes('image-style-align-left') || classes.includes('align-left')) {
						imageAlignment = 'left';
						inlineStyle += `float: left; margin-right: 10px; `;
					} else if (classes.includes('image-style-align-right') || classes.includes('align-right')) {
						imageAlignment = 'right'; 
						inlineStyle += `float: right; margin-left: 10px; `;
					} else if (classes.includes('image-style-align-center') || classes.includes('align-center')) {
						imageAlignment = 'center';
						inlineStyle += `display: block; margin-left: auto; margin-right: auto; `;
					}
					newAttributes += ` class="${classes}"`;
				}
				
				if (alignMatch && !imageAlignment) {
					const align = alignMatch[1].toLowerCase();
					if (align === 'left') {
						inlineStyle += `float: left; margin-right: 10px; `;
					} else if (align === 'right') {
						inlineStyle += `float: right; margin-left: 10px; `;
					} else if (align === 'center') {
						inlineStyle += `display: block; margin-left: auto; margin-right: auto; `;
					}
					newAttributes += ` align="${alignMatch[1]}"`;
				}
				
				if (styleMatch) {
					let existingStyle = styleMatch[1];
					
					const cssWidthMatch = existingStyle.match(/width\s*:\s*(\d+(?:\.\d+)?)px/i);
					const cssHeightMatch = existingStyle.match(/height\s*:\s*(\d+(?:\.\d+)?)px/i);
					
					if (cssWidthMatch && !widthMatch) {
						const width = Math.round(parseFloat(cssWidthMatch[1]));
						newAttributes += ` width="${width}"`;
						inlineStyle += `width: ${width}px; `;
					}
					if (cssHeightMatch && !heightMatch) {
						const height = Math.round(parseFloat(cssHeightMatch[1]));
						newAttributes += ` height="${height}"`;
						inlineStyle += `height: ${height}px; `;
					}
					
					if (!imageAlignment) {
						if (existingStyle.includes('float: left') || existingStyle.includes('float:left')) {
							inlineStyle += `float: left; margin-right: 10px; `;
						} else if (existingStyle.includes('float: right') || existingStyle.includes('float:right')) {
							inlineStyle += `float: right; margin-left: 10px; `;
						} else if (existingStyle.includes('margin-left: auto') && existingStyle.includes('margin-right: auto')) {
							inlineStyle += `display: block; margin-left: auto; margin-right: auto; `;
						}
					}
					
					inlineStyle += existingStyle;
				}
				
				const otherAttributes = allAttributes
					.replace(/\bwidth\s*=\s*["']?\d+(?:\.\d+)?["']?/gi, '')
					.replace(/\bheight\s*=\s*["']?\d+(?:\.\d+)?["']?/gi, '')
					.replace(/\bclass\s*=\s*["'][^"']*["']/gi, '')
					.replace(/\balign\s*=\s*["'][^"']*["']/gi, '')
					.replace(/\bstyle\s*=\s*["'][^"']*["']/gi, '')
					.trim();
				
				let finalAttributes = `src="${dataURI}"${newAttributes}`;
				if (otherAttributes) {
					finalAttributes += ` ${otherAttributes}`;
				}
				if (inlineStyle) {
					finalAttributes += ` style="${inlineStyle.trim()}"`;
				}
				
				return `<img ${finalAttributes}>`;
			}
		);
		
		return { processedContent, attachmentIds: [] };
	}
	
	// Original logic: Convert base64 to server URLs
	const imgRegex = /<img[^>]+src="data:image\/[^"]*"[^>]*>/g;
	const dataURIRegex = /src="(data:image\/[^"]*)"/;
	
	let processedContent = htmlContent;
	const matches = htmlContent.match(imgRegex);
	const attachmentIds = [];
	
	if (!matches) {
		return { processedContent: htmlContent, attachmentIds: [] };
	}
	
	for (const imgTag of matches) {
		const dataURIMatch = imgTag.match(dataURIRegex);
		if (dataURIMatch) {
			const dataURI = dataURIMatch[1];
			
			try {
				const blob = dataURItoBlobs(dataURI);
				
				const fd = new FormData();
				fd.append('uploadfile', blob, 'inline-image.png');
				fd.append('eventType', 'paste');
				fd.append('fileType', blob.type);
				
				const uploadResponse = await $.ajax({
					url: webserverRoot + "errand/uploadAnswerAttachment",
					data: fd,
					processData: false,
					contentType: false,
					type: 'POST'
				});
				
				let imageUrl = uploadResponse.download;
				if (imageUrl && !imageUrl.startsWith('http') && !imageUrl.startsWith('/')) {
					imageUrl = '/' + imageUrl;
				}
				
				const newImgTag = imgTag.replace(
					dataURIRegex, 
					`src="${imageUrl}" data-original-src="${dataURI}"`
				);
				
				processedContent = processedContent.replace(imgTag, newImgTag);
				
				if (uploadResponse.id) {
					// Keep the original string format as expected by backend
					attachmentIds.push(uploadResponse.id);
				}
				
			} catch (error) {
				console.error('Failed to upload inline image in collaboration:', error);
			}
		}
	}
	
	return { processedContent, attachmentIds };
};

const processCollaborationContentInlineImages = async (param, isInternalAnswer = false) => {
	let processedParam = { ...param };
	// NOTE: Create two versions of the content:
	// 1. htmlBody/message with server URLs (for agent view display)
	// 2. htmlBody_for_email/message_for_email with base64 (for email sending)
	// This follows the same pattern as manual errands (update_answer and update_answer_for_email)
	
	// For external collaboration queries, process htmlBody
	if (!isInternalAnswer && processedParam.htmlBody) {
		const originalContent = processedParam.htmlBody;

		// Agent view: Upload images and convert to server URLs
		const { processedContent: agentContent } = await processCollaborationInlineImages(originalContent, false);
		processedParam.htmlBody = agentContent;
		
		// Client/Email view: Preserve base64 images with proper styling
		const { processedContent: emailContent } = await processCollaborationInlineImages(originalContent, true);
		processedParam.htmlBody_for_email = emailContent;
	}

	if (isInternalAnswer && processedParam.message) {
		const originalMessage = processedParam.message;
		
		// Agent view: Upload images and convert to server URLs
		const { processedContent: agentContent } = await processCollaborationInlineImages(originalMessage, false);
		processedParam.message = agentContent;
		// Don't add attachmentIds - inline images should not be sent as separate attachments
		
		const { processedContent: clientContent } = await processCollaborationInlineImages(originalMessage, true);
		processedParam.messageForEmail = clientContent;
		
		// Client/Email view: Preserve base64 images with proper styling
		const { processedContent: emailContent } = await processCollaborationInlineImages(originalMessage, true);
		processedParam.message_for_email = emailContent;
	}

	return processedParam;
};

const checkIfClientCollaborationContext = (option, param) => {

	return true;
};



function getIDsFromArrayObject(array) {
	let uploaded = [];
	$.each(array, (i,v) => {
		uploaded.push(v.id);
	});
	return uploaded;
}

function createUpdateExpertObject(state, force, autoSave, option) {
	const e = state.app.errand, c = e.collaborationInputs,
		errandID = e.currentErrand.id;
    const hc = e.fetchHistory.data.opr;
    let selectedErrands = [];
    $.each(hc, (k, v) => {
        if (v.selected) {
            // doesn't care whether int or string as later it'll turn
            // into string no matter how.
            selectedErrands.push(k);
        }
	});
	selectedErrands.reverse();
    let selectedHistory = selectedErrands.join(',');
	let uploaded = getIDsFromArrayObject(c.uploaded_attachments);
	let saved = getIDsFromArrayObject(c.saved_attachments);

	return {
		errandID: errandID,
		queryID: c.queryID,
		answerID: c.answerID,
		signature: c.update_signature,
		subject: c.update_subject,
		internals: c.selectedAgents,
		areas: c.selectedAreas,
		collabChannel: currentCollabChannel(state),
		externalExpertAddresses: getUniqueAddress(c.update_to),
		ccAddresses: getUniqueAddress(c.update_cc),
		bccAddresses: getUniqueAddress(c.update_bcc),
		saveRecipient: c.saveRecipient,
		includeCollabHistory: c.threadID != 0 ? c.includeCollabHistory : false,
		includeErrandHistory: c.includeErrandHistory,
		htmlBody: checkEmptyHTML(c.update_answer, c.plain_answer),
		selectedAttachment: c.selectedAttachment,
		attachments: getIDsFromArrayObject(c.uploaded_attachments),
		savedAttachments: getIDsFromArrayObject(c.saved_attachments),
		archiveAttachments: getIDsFromArrayObject(c.archive_attachments),
		libraryAttachments: getIDsFromArrayObject(c.library_attachments),
		messageHistory: selectedHistory,
		threadID: c.threadID,
		savedQueryID: c.savedQueryID,
		forceSave: force,
		autoSave: autoSave
	};
}

const optReplyCollaborate = {reply: RPLY_COLLABORATE};

const collaborationTranslate = (param, option) => checkTranslate(param, option, true, false);
const canSendCollabToChannel = (param, option) => canSendCollab(param, option);

// Send an expert query.
const sendExpertQuery = chat => async (dispatch, getState) => {
	const e = getState().app.errand
	const { id } = e.currentErrand
	const { threadID } = e.collaborationInputs
	const option = optReplyCollaborate
	dispatch(updateExpertAnswerState(EXPERT_ANS_SENDING));
	const param = createUpdateExpertObject(getState(), true, false, option);
	
	try {
		const processedParam = await processCollaborationContentInlineImages(param, false);
		
		dispatch(checkEmptyRecipient(processedParam, option))
			.then(({param, option}) => dispatch(checkEmptyAnswer(param, option)))
			.then(({param, option}) => dispatch(collaborationTranslate(param, option)))
			.then(({param, option}) => dispatch(canSendCollabToChannel(param, option)))
			.then(({param}) => dispatch(sendEE(param)))
			.then(() => {
				dispatch(refreshCollaborationData(id, threadID, chat));
				dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
			})
			.catch(err => {
				dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
			});
	} catch (error) {
		dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
	}
};

// passing empty argument meaning changing reply type which do not has any
// specific expert creation unless it is first time loading the expert creation
// which will create new expert thread for it.
const prepareCreateExpertQuery = (errandID, threadID, queryID, answerID) => (dispatch, getState) => {
	const state = getState(), e = state.app.errand,
		expert = e.collaborationInputs, preErrandID = e.currentErrand.id;
	if(expert.replyQuery) {
		let updateThreadID;
		if(threadID) {
			updateThreadID = threadID;
		} else {
			updateThreadID = 0;
		}
		dispatch(changeCollaborationRole(ROLE_AGENT, updateThreadID));
	}
	if(!errandID) {
		// creating new expert thread under current errand.
		threadID = 0;
		queryID = 0;
		answerID = 0;
	} else {
		if(errandID !== preErrandID) {
			return;
		}
	}
	errandID = preErrandID;
	const {queryID: preQueryID, answerID: preAnswerID} = expert,
		preIDs = externalExpertEditDomainID(preErrandID, preQueryID,
			preAnswerID),
		currIDs = externalExpertEditDomainID(errandID, queryID, answerID);
	if(expert.errandID && preIDs === currIDs) {
		// do nothing if previous editing is same and it is first time create
		// new thread.
		return;
	}
	dispatch(eeEdit(errandID, queryID, answerID))
		.then(() => {
			dispatch(updateCurrentExpertIDs(errandID, threadID, queryID,
				answerID));
		});
};

const prepareSavedExpertQuery = (errandID, threadID, queryID, answerID) => (dispatch, getState) => {
	const state = getState(), e = state.app.errand,
		expert = e.collaborationInputs, preErrandID = e.currentErrand.id;
	if(expert.replyQuery) {
		let updateThreadID;
		if(threadID) {
			updateThreadID = threadID;
		} else {
			updateThreadID = 0;
		}
		dispatch(changeCollaborationRole(ROLE_AGENT, updateThreadID));
	}
	if(!errandID) {
		// creating new expert thread under current errand.
		threadID = 0;
		queryID = 0;
		answerID = 0;
	} else {
		if(errandID !== preErrandID) {
			return;
		}
	}

	errandID = preErrandID;
	const {queryID: preQueryID, answerID: preAnswerID} = expert,
		preIDs = externalExpertEditDomainID(preErrandID, preQueryID,
			preAnswerID),
		currIDs = externalExpertEditDomainID(errandID, queryID, answerID);
	if(expert.errandID && preIDs === currIDs) {
		// do nothing if previous editing is same and it is first time create
		// new thread.
		return;
	}
	dispatch(eeEdit(errandID, queryID, answerID))
		.then(() => {
			dispatch(updateCurrentExpertIDs(errandID, threadID, queryID,
				answerID));
		});
};
export const replyExpertQuery = (errandID, threadID, queryID, answerID) => (dispatch, getState) => {
	dispatch(prepareCreateExpertQuery(errandID, threadID, queryID, answerID));
	dispatch(selectShowReply(RPLY_COLLABORATE, true));
};
export const reSendExpert = (errandID, threadID, queryID, answerID) => (dispatch, getState) => {
	dispatch(reSendExpertEmail(errandID, threadID, queryID, answerID));
	dispatch(selectShowReply(RPLY_COLLABORATE, true));
}
export const editExpertQuery = (errandID, threadID, queryID, answerID) => (dispatch, getState) => {
	dispatch(prepareSavedExpertQuery(errandID, threadID, queryID, answerID));
	dispatch(selectShowReply(RPLY_COLLABORATE, true));
};
// create new external expert thread.
export const createExpertQueryThread = () => (dispatch, getState) => {
	dispatch(prepareCreateExpertQuery());
	dispatch(selectShowReply(RPLY_COLLABORATE, true));
};

const getInternalChatData = (chat, which) => dispatch => {
	if (!isChatAndCollaborateInternalChat(chat, which)) {
		return;
	}
	dispatch({ type: CHAT_GETTING_CANDIDATES, chat });
	dispatch(getChatCandidates())
	.then(
		response => {
			subscribeAgentPresence();
			dispatch({ type: CHAT_SET_CANDIDATES, chat, response });
		},
		failed => { // TODO: this isn't common pattern for promise failure
			dispatch({ type: CHAT_DONE_GETTING_CANDIDATES, chat });
			dispatch(togglePopAlert(I("An error occurred while getting the agent list.")));
		}
	);
}

const selectShowReplyChatAware = (
	dispatch,
	chat,
	previousShow,
	which,
	currentShow
) => {
	if (chat) {
			dispatch(selectChatReplyTab(false));
			if (previousShow) {
				dispatch(selectShowReply(which, currentShow));
			} else {
				dispatch(selectShowReply(which, false));
				dispatch(toggleChatNavDD(false));
			}
	} else {
		dispatch(selectShowReply(which, currentShow));
	}
}

export const changeReply = (which, show) => (dispatch, getState) => {
	const state = getState()
	const chat = state.app.errand.chat
	if (isChatAndCollaborateInternalChat(chat, which)) {
		changeHistorySelections(dispatch, state, which);
		dispatch(getInternalChatData(chat, which));
		dispatch(selectShowReply(which));
		return;
	} else if (chat) {
		dispatch({
			type: CHAT_SET_CANDIDATES,
			chat,
			response: { list: emptyArray }
		});
		unsubscribeAgentPresence();
	}
	const previousShow = state.app.errand.ui.reply.show
	if (!isCollaboration(which)) {
		selectShowReplyChatAware(dispatch, chat, previousShow, which, show)
		// Pre-select current errand for forward to external
		changeHistorySelections(dispatch, state, which);
		return;
	}
	// only collaboration fall to here.
	changeHistorySelections(dispatch, state, which);
	if (!state.app.errand.collaborationInputs.errandID) {
		// first time access collaboration reply
		let errandId = state.app.errand.currentErrand.id
		dispatch(invalidateCache(externalExpertEditDomainID(errandId, 0, 0), D_EE_EDIT));
		dispatch(prepareCreateExpertQuery())
		show = true
	}
	selectShowReplyChatAware(dispatch, chat, previousShow, which, show)
};

export const loadCollaboration = which => (dispatch, getState) => {
	const state = getState();
	const chat = state.app.errand.chat;
	changeHistorySelections(dispatch, state, which);
	dispatch(getInternalChatData(chat, which));
}

function createInternalAnswerCollaboration(state, query) {
	const e = state.app.errand, c = e.collaborationInputs;
	return {
		param: {
			internal: true,
			query,
			message: checkEmptyHTML(c.update_answer, c.plain_answer),
			attachments: getIDsFromArrayObject(c.uploaded_attachments),
		},
		option: update(optReplyCollaborate, {answerQuery: {$set: true}})
	};
}

const answerCollaborationQuery = queryID => async (dispatch, getState) => {
	dispatch(updateExpertAnswerState(EXPERT_ANS_SENDING));
	const state = getState(), e = state.app.errand, {id} = e.currentErrand,
		{param, option} = createInternalAnswerCollaboration(state, queryID),
		{threadID} = e.collaborationInputs;
	
	try {
		const processedParam = await processCollaborationContentInlineImages(param, true);
		
		dispatch(checkEmptyAnswer(processedParam, option))
			.then(({param, option}) => dispatch(collaborationTranslate(param, option)))
			.then(({param}) => dispatch(answerQuery(param)))
			.then(() => {
				dispatch(refreshCollaborationData(id, threadID));
			dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
		})
		.catch(err => {
			dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
		});
	} catch (error) {
		console.error('Failed to process inline images in collaboration answer:', error);
		dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
	}
};

export const submitCollaboration = chat => (dispatch, getState) => {
	const c = getState().app.errand.collaborationInputs;
	if (!c.replyQuery) {
		dispatch(sendExpertQuery(chat));
	} else {
		dispatch(answerCollaborationQuery(c.queryID, chat));
	}
};

const rawSaveCollab = (force, isAutoSave) => async (dispatch, getState) => {
	dispatch(saveCollabStart());
	const state = getState()
		, e = state.app.errand
		, id = e.currentErrand.id
		, threadID = e.collaborationInputs.threadID

		;
	dispatch(updateExpertAnswerState(EXPERT_ANS_SAVING));
	if (!force && !isCollabInputsChangedMemoize(state)) {
		dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
		// promise must resolve with undefined here as indication of no saving
		// occurs.
		return Promise.resolve();
	}
	const option = optReplyCollaborate
	const param = createUpdateExpertObject(getState(), force, isAutoSave, option);
	
	try {
		// Process inline images before saving
		const processedParam = await processCollaborationContentInlineImages(param, false);
		
		return dispatch(collaborationTranslate(processedParam, option))
			.then(({param, option}) => dispatch(canSendCollabToChannel(param, option)))
			.then(({param}) => dispatch(updateEE(param)))
			.then(data => {
				const { result, error } = mcamResult(data);
				if (error) {
					return Promise.reject({err: error});
				}
				dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));

				// invalidate cache upon successful save, 
				// so that edit the same query will fetch the latest data			
				let collabInputs = collaborationInputs(getState())
				let errandID = collabInputs.errandID;
				let queryID = collabInputs.queryID;
				let answerID = collabInputs.answerID;
				dispatch(invalidateCache(externalExpertEditDomainID(errandID, queryID, answerID), D_EE_EDIT));

				// reload the EE thread, so that changes are visible in EE thread
				const q = {thread: threadID, errand: errandID, read: true, lightoff: true};
				dispatch(async(getExternalexpertThread(q), errandMap[keyFetchExternalExpertThread], q))
				.then(() => dispatch(multiDispatchesEE(id, true)))
			.then(() => ({result: result.result}))
		})
		.catch(err => {
			dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
		});
	} catch (error) {
		console.error('Failed to process inline images in collaboration save:', error);
		dispatch(updateExpertAnswerState(EXPERT_ANS_IDLE));
		return Promise.reject({err: error});
	}
};

export const rawHardSaveCollab = (force, shouldLoadList) => dispatch =>
	dispatch(rawSaveCollab(force, true))
		.then(() => {
			dispatch(markEELastSaveTriggered(true));
			if (shouldLoadList) {
				dispatch(loadList("rawHardSaveCollab"));
			}
		});

		export const reSendExpertEmail = (errandID, threadID, queryID, answerID) => (dispatch, getState) => {
			const params = { errandID, threadID, queryID, answerID }; 
			return dispatch(
				async () =>
					postResendExternalexpertSend({ params: JSON.stringify(params) })()
			)
				.then((response) => {
					if (!response.success) {
						return Promise.reject(new Error(response.error));
					}
					return response;
				})
				.catch((err) => {
					dispatch(popErrorOnly(err));
					// TODO: send notification error here
				});
		};	
export const saveCollabIfNeeded = () => (dispatch, getState) => {
	let state = getState();
	if (!isEEActionInProgressSelector(state)) {
		let hasChanged = isCollabInputsChangedMemoize(getState());
		let unsavedAttachments = getEEUploadedAttachments(getState());
		if (hasChanged || unsavedAttachments) {
			dispatch(togglePopWaiting(I("Please wait while saving collaboration...")));
			return dispatch(rawHardSaveCollab(true, false))
			.then(() => {
				dispatch(clearPopWaiting());
			})
			.catch(err => {
				dispatch(clearPopWaiting());
			});
		} else {
			return Promise.resolve();
		}	
	} else {
		return Promise.resolve();
	}	
}

function saveCollabFactory() {
	let lastTimeout = Date.now();
	return isAutoSaveTimeout => (dispatch, getState) => {
		if (!isAutoSaveTimeout && (Date.now() - lastTimeout) < TMR_AUTO_SAVE) {
			// when agent stopped typing and before auto save timeout
			return;
		}
		const state = getState()
			, errand = state.app.errand
			;
		if (!isEEActionInProgressSelector(state)
			&& isEEIdleAnswer(state)
			&& errand.ui.lastSaveEE.canSave) {
			return dispatch(rawSaveCollab(false, true))
				.then(result => {
					if (!getState().app.errand.ui.lastSaveEE.triggered) {
						dispatch(markEELastSaveTriggered(true));
					}
					if (result && result.result) {
						lastTimeout = Date.now();
					}
				});
		} else {
			return dispatch(saveCollabStart());
		}
	};
}

const tmrAgentIdle = TMR_AGENT_NO_TYPING + THROTTLED_TMR;

export const enableAutoSaveCollab = () => dispatch => {
	const saveCollabFunc = saveCollabFactory();
	dispatch(addTimeout(
		tmrAgentIdle
		, AGENTEE_BUSY_TYPING
		, () => {
			// run this function if AGENTEE_BUSY_TYPING (action) has not been
			// dispatched in tmrAgentIdle amount of time
			dispatch(agentEENotTyping());
			dispatch(saveCollabFunc(false));
		}
	));
	// run save EE if SAVE_EE (action) has not been dispatched in 
	// TMR_AUTO_SAVE amount of time
	return dispatch(addTimeout(
		TMR_AUTO_SAVE
		, SAVE_EE
		, () => dispatch(saveCollabFunc(true))
	));
};

export const stopAutoSaveCollab = () => dispatch => {
	dispatch(removeTimeout(SAVE_EE));
	dispatch(removeTimeout(AGENTEE_BUSY_TYPING));
};

export const enableCollaborationBase64Preservation = (option = {}) => {
	console.warn('⚠️  Enabling base64 preservation for collaboration - this should ONLY be used for true client contexts');
	return {
		...option,
		preserveBase64ForClient: true,
		isClientView: true
	};
};

export const enableGlobalCollaborationBase64Preservation = () => {
	console.error('⚠️  WARNING: Enabling global collaboration base64 preservation will break agent web view functionality!');
	console.error('⚠️  This should ONLY be used for debugging client view issues');
	
	const originalCheck = checkIfClientCollaborationContext;
	window.checkIfClientCollaborationContext = () => {
		console.warn('🔧 Force-preserving base64 for collaboration (agent functionality may be broken)');
		return true;
	};
	
	console.log('🔧 Global collaboration base64 preservation enabled - agent web view functionality is now broken');
	
	return () => {
		window.checkIfClientCollaborationContext = originalCheck;
		console.log('🔧 Global collaboration base64 preservation disabled - agent web view restored');
	};
};

export const debugCollaborationClientView = () => {
	console.warn('🐛 DEBUG MODE: This will break agent web view functionality!');
	return enableGlobalCollaborationBase64Preservation();
};
